(function () {
  'use strict';

  var wrapper, steps, totalSteps, currentStep, score;
  var redirectNovice, redirectNavigator, redirectNerd;
  var storageKey;

  function init() {
    wrapper = document.querySelector('.cn-knowledge-quiz');
    if (!wrapper) return;

    steps = wrapper.querySelectorAll('.ckq-step');
    totalSteps = steps.length;
    if (totalSteps === 0) return;

    currentStep = 0;
    score = 0;

    redirectNovice = wrapper.dataset.redirectNovice;
    redirectNavigator = wrapper.dataset.redirectNavigator;
    redirectNerd = wrapper.dataset.redirectNerd;
    storageKey = wrapper.dataset.storageKey || 'ckq-knowledge-score';

    showStep(0);

    document.getElementById('ckq-back').addEventListener('click', function (e) {
      e.preventDefault();
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
        scrollToSteps();
      }
    });

    document.getElementById('ckq-next').addEventListener('click', function (e) {
      e.preventDefault();
      if (currentStep < totalSteps - 1) {
        currentStep++;
        showStep(currentStep);
        scrollToSteps();
      }
    });

    document.getElementById('ckq-submit').addEventListener('click', function (e) {
      e.preventDefault();
      if (steps[currentStep].dataset.answered === 'true') {
        handleSubmit();
      }
    });

    for (var i = 0; i < steps.length; i++) {
      bindRadios(steps[i]);
    }
  }

  function bindRadios(step) {
    var radios = step.querySelectorAll('.ckq-radio-input');
    for (var j = 0; j < radios.length; j++) {
      radios[j].addEventListener('change', function (e) {
        onAnswerChange(e, step);
      });
    }
  }

  function showStep(n) {
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.remove('is-active');
    }
    steps[n].classList.add('is-active');
    updateProgress();
    updateNav();
  }

  function updateProgress() {
    var bar = wrapper.querySelector('.ckq-progress-bar');
    var indicator = document.getElementById('ckq-current-step');
    if (bar) bar.style.width = ((currentStep + 1) / totalSteps * 100) + '%';
    if (indicator) indicator.textContent = currentStep + 1;
  }

  function updateNav() {
    var backBtn = document.getElementById('ckq-back');
    var nextBtn = document.getElementById('ckq-next');
    var submitBtn = document.getElementById('ckq-submit');
    var answered = steps[currentStep].dataset.answered === 'true';
    var isLast = currentStep === totalSteps - 1;

    if (currentStep === 0) {
      backBtn.classList.add('disabled');
    } else {
      backBtn.classList.remove('disabled');
    }

    if (isLast) {
      nextBtn.style.display = 'none';
      submitBtn.style.display = '';
      if (answered) {
        submitBtn.classList.remove('disabled');
      } else {
        submitBtn.classList.add('disabled');
      }
    } else {
      nextBtn.style.display = '';
      submitBtn.style.display = 'none';
      if (answered) {
        nextBtn.classList.remove('disabled');
      } else {
        nextBtn.classList.add('disabled');
      }
    }
  }

  function onAnswerChange(e, step) {
    if (step.dataset.answered === 'true') return;

    var selectedInput = e.target;
    var selectedLabel = selectedInput.closest('.ckq-radio-item');
    if (!selectedLabel) return;

    var isCorrect = selectedLabel.dataset.correct === 'true';

    var allInputs = step.querySelectorAll('.ckq-radio-input');
    for (var i = 0; i < allInputs.length; i++) {
      allInputs[i].disabled = true;
    }

    var allLabels = step.querySelectorAll('.ckq-radio-item');
    for (var j = 0; j < allLabels.length; j++) {
      if (allLabels[j].dataset.correct === 'true') {
        allLabels[j].classList.add('right');
      }
    }

    if (!isCorrect) {
      selectedLabel.classList.add('wrong');
    } else {
      score++;
    }

    step.dataset.answered = 'true';
    updateNav();

    setTimeout(function () {
      var navProgress = wrapper.querySelector('.ckq-nav-progress');
      if (navProgress) {
        navProgress.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 300);
  }

  function scrollToSteps() {
    var stepsWrap = wrapper.querySelector('.ckq-steps-wrap');
    if (stepsWrap) {
      stepsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function handleSubmit() {
    var redirectUrl;
    if (score <= 3) {
      redirectUrl = redirectNovice;
    } else if (score <= 7) {
      redirectUrl = redirectNavigator;
    } else {
      redirectUrl = redirectNerd;
    }
    try {
      localStorage.setItem(storageKey, score);
    } catch (e) {}
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      window.location.reload();
    }
  });
})();
